const BlankStateIcon = ({ className, ...props }: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width={437}
      height={130}
      viewBox="0 0 437 130"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path d="M0.5 108.932H107.012" stroke="#DAE0E5" strokeLinecap="square" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M167.787 87.6485C167.787 87.6485 155.957 83.8107 146.905 85.8526C137.853 87.8945 134.766 95.0973 134.766 95.0973C134.766 95.0973 126.139 96.6828 119.271 100.068C112.403 103.454 107 108.785 107 108.785C107 108.785 108.707 101.509 113.624 96.7572C118.541 92.0055 126.765 89.6845 126.765 89.6845C126.765 89.6845 134.774 78.1725 144.895 75.9359C155.017 73.6993 167.787 80.6198 167.787 80.6198"
        fill="#EFF2F5"
      />
      <path d="M107.032 108.942C107.032 108.942 111.044 94.055 127.095 90.269" stroke="#DAE0E5" />
      <path
        d="M178.397 98.0897C178.397 98.0897 174.133 86.368 169.692 82.8825C154.789 71.1843 137.052 74.3788 127.011 90.3278"
        stroke="#DAE0E5"
      />
      <path d="M436.5 75.8899H329.988" stroke="#DAE0E5" strokeLinecap="square" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M269.213 54.6065C269.213 54.6065 281.043 50.7687 290.095 52.8106C299.147 54.8526 302.234 62.0553 302.234 62.0553C302.234 62.0553 310.861 63.6408 317.729 67.0263C324.597 70.4119 330 75.7432 330 75.7432C330 75.7432 328.293 68.467 323.376 63.7152C318.459 58.9635 310.235 56.6425 310.235 56.6425C310.235 56.6425 302.226 45.1305 292.105 42.8939C281.983 40.6573 269.213 47.5779 269.213 47.5779"
        fill="#EFF2F5"
      />
      <path d="M329.968 75.8998C329.968 75.8998 325.956 61.013 309.905 57.2271" stroke="#DAE0E5" />
      <path
        d="M258.603 65.0477C258.603 65.0477 262.867 53.326 267.308 49.8405C282.211 38.1423 299.948 41.3368 309.989 57.2858"
        stroke="#DAE0E5"
      />
      <path
        d="M216.899 10.271C217.653 9.82573 218.589 9.82571 219.342 10.271L267.862 38.9575C268.593 39.3893 269.041 40.1744 269.041 41.0229V101.919C269.041 102.824 268.532 103.651 267.726 104.06L219.205 128.649C218.523 128.994 217.718 128.994 217.036 128.649L168.515 104.06C167.708 103.651 167.2 102.824 167.2 101.919V41.0229C167.2 40.1744 167.648 39.3894 168.379 38.9575L216.899 10.271Z"
        fill="white"
        stroke="#DAE0E5"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M217.306 10.9593C217.809 10.6624 218.433 10.6624 218.935 10.9593L268.241 40.1101L218.852 65.4927C218.393 65.7286 217.848 65.7286 217.389 65.4927L168 40.1101L217.306 10.9593Z"
        fill="#EFF2F5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M189.972 65.67V4.80353C189.972 2.7029 191.217 1 192.763 1H244.262C245.804 1 247.053 2.69261 247.053 4.80353V65.67"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M189.972 51.0925V3.94616C189.972 2.31904 191.217 1 192.763 1H244.262C245.804 1 247.053 2.31107 247.053 3.94616V51.0925"
        fill="white"
      />
      <path
        d="M189.972 51.0925V3.94616C189.972 2.31904 191.217 1 192.763 1H244.262C245.804 1 247.053 2.31107 247.053 3.94616V51.0925"
        stroke="#DAE0E5"
        strokeWidth="2"
      />
      <path d="M168 39.8042L218 65.9058V129" stroke="#DAE0E5" strokeWidth="1.6" />
      <path d="M268 39.8042L218 65.9058V129" stroke="#DAE0E5" strokeWidth="1.6" />
      <path
        d="M199.421 34.1596H236.212"
        stroke="#EFF2F5"
        strokeWidth="1.28"
        strokeLinecap="round"
      />
      <path d="M198.02 42.6259H209.767" stroke="#DAE0E5" strokeWidth="1.28" strokeLinecap="round" />
      <path
        d="M214.728 42.6259H226.475"
        stroke="#EFF2F5"
        strokeWidth="1.28"
        strokeLinecap="round"
      />
      <path
        d="M230.037 42.6259H236.225"
        stroke="#EFF2F5"
        strokeWidth="1.28"
        strokeLinecap="round"
      />
      <path d="M223.95 24.2823H236.206" stroke="#DAE0E5" strokeWidth="1.28" strokeLinecap="round" />
      <path
        d="M199.419 24.2823H216.941"
        stroke="#EFF2F5"
        strokeWidth="1.28"
        strokeLinecap="round"
      />
      <path
        d="M211.958 52.5033H231.739"
        stroke="#DAE0E5"
        strokeWidth="1.28"
        strokeLinecap="round"
      />
      <path
        d="M199.419 52.5033H204.193"
        stroke="#EFF2F5"
        strokeWidth="1.28"
        strokeLinecap="round"
      />
      <path
        d="M199.428 15.8158H227.852"
        stroke="#DAE0E5"
        strokeWidth="1.28"
        strokeLinecap="round"
      />
      <path
        d="M231.441 15.8158H236.214"
        stroke="#EFF2F5"
        strokeWidth="1.28"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default BlankStateIcon;
